export enum NavigationRoutes {
    Default = '/',
    Home = '/',
    About = 'about',
    Stories = 'stories',
    VideoTelling  = 'video-telling',
    Story = 'story',
    Resources = 'resources',
    Blog = 'blogs',
    SinlgeBlog = 'blog',
    Links = 'home#links',
    Login = "login",
    Admin = "admin"
}

export const links: NavigationRoutes[] = [
    NavigationRoutes.Home,
    NavigationRoutes.About,
    NavigationRoutes.Stories,
    NavigationRoutes.VideoTelling,
    NavigationRoutes.Resources,
    NavigationRoutes.Blog,
    NavigationRoutes.SinlgeBlog,
];
export const pages = ['Home', 'About', 'Implementation Stories', 'Video Telling & Webinars', 'Resources', 'Blog'];

export const customNavigate = (navigate: any, route: NavigationRoutes) => {
    navigate(`/${route.replaceAll("/", "")}`);
    window.scrollTo(0, 0);
}
